<template>
   <div>
      证书核验
   </div>
</template>
<script>
export default {
   name: 'DCIRegistration',
   components: {
     
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
       
     }
   },
   computed: {
     
   },
   watch: {
     
   },
   mounted() {
     
   },
   methods: {
     
   }
};
</script>
<style lang='scss' scoped>
</style>